import { PreloadedFrame } from 'types/dnaHub';

const supportsCreateImageBitmap = typeof window !== 'undefined' && 'createImageBitmap' in window;

const loadFrame = async (url: string): Promise<PreloadedFrame> => {
  if (supportsCreateImageBitmap) {
    const response = await fetch(url);
    const blob = await response.blob();
    return createImageBitmap(blob);
  }

  const img = new Image();
  img.decoding = 'async';
  img.src = url;
  await img.decode();
  return img;
};

export interface PreloadResult {
  frames: PreloadedFrame[];
  totalDecodeTimeMs: number;
}

export const preloadFrames = async (
  count: number,
  getUrl: (index: number) => string,
  onFrameLoaded?: (loadedCount: number) => void,
): Promise<PreloadResult> => {
  const frames = new Array<PreloadedFrame>(count);
  let loadedCount = 0;
  const start = performance.now();

  await Promise.all(
    Array.from({ length: count }, async (_unused, index) => {
      frames[index] = await loadFrame(getUrl(index));
      loadedCount += 1;
      onFrameLoaded?.(loadedCount);
    }),
  );

  return { frames, totalDecodeTimeMs: performance.now() - start };
};
